import type { Categoria } from '../../core/api/types'
import { useI18n } from '../../core/i18n/useI18n'
import { categoryLabel } from '../categoryLabels'

export function CategoryLabel({
  category,
  empty = '—',
}: {
  category: Categoria | null | undefined
  empty?: string
}) {
  const { t } = useI18n()
  return <>{category ? categoryLabel(category, t) : empty}</>
}
